import React from "react";

import { useSelector } from "react-redux";

import GeneralAccessManagement from "./GeneralAccess";
import ProfileViewManagement from "./View";

// Import utilities
import { isAllowedToDo, isAllowedToDoByKey } from "permissions-hub";
import {
  DESIGNATION_MANAGEMENT,
  TEAM_MANAGEMENT,
  SHIFT_MANAGEMENT,
  ROLE_MANAGEMENT,
  ACCEPTED_PERMISSIONS,
  EMPLOYEE_MANAGEMENT,
} from "constants";
import { getAllowedPermissions } from "utils/authentication";

// Importing common components
import WarningAlert from "common/Alert";

const ProfileManagement = ({ permissions }) => {
  const { userInfo: loggedUserInfo } = useSelector((state) => state.auth);

  // ?? Check 'Read' permission of designation, team, shift & role management.

  // Check read permission of designation
  const isAllowedToReadDesignation = isAllowedToDoByKey(
    DESIGNATION_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  const isAllowedToReadTeam = isAllowedToDoByKey(
    TEAM_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  const isAllowedToReadShift = isAllowedToDoByKey(
    SHIFT_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  const isAllowedToReadRole = isAllowedToDoByKey(
    ROLE_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  // Check delete permission in employee
  const isAllowedToDeleteInEmployee = isAllowedToDoByKey(
    EMPLOYEE_MANAGEMENT,
    ACCEPTED_PERMISSIONS["delete"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  // Check read permission
  const isAllowedToRead = isAllowedToDo(
    ACCEPTED_PERMISSIONS["read"],
    permissions
  );

  // Check update permission
  const isAllowedToUpdate = isAllowedToDo(
    ACCEPTED_PERMISSIONS["update"],
    permissions
  );

  // Pass ProfileViewManagement as a prop if isGeneralAccess is true
  if (isAllowedToUpdate) {
    const ManagementComponent = (
      <GeneralAccessManagement
        isAllowedToDelete={isAllowedToDeleteInEmployee}
      />
    );

    return !(
      isAllowedToReadDesignation &&
      isAllowedToReadTeam &&
      isAllowedToReadShift &&
      isAllowedToReadRole
    ) ? (
      <WarningAlert
        message="<p>In order to effectively manage the system, you need to have read permissions for <strong>Designation, Team, Shift, and Role management</strong>. If you are an administrator, you can enable these permissions from the role management section.</p>
      <hr/> <p class='mb-0'>If you need further assistance, please contact the developer at <a href='mailto:ankitbattersea@gmail.com' >ankitbattersea@gmail.com</a>.</p>"
      />
    ) : (
      ManagementComponent
    );
  } else if (isAllowedToRead) {
    return <ProfileViewManagement />;
  }
};

export default ProfileManagement;
